<template lang="pug">
portal.portal(selector=".topic-event-form-portal")
  ConfirmationDialogProvider
    .d-flex.flex-column.flex-sm-row.justify-center.justify-sm-end
      TopicForm.pa-1.px-sm-1.py-sm-0(
        v-if="canCreateTopic",
        :isEdit="false"
      )
      EventSheetButton.pa-1.px-sm-1.py-sm-0(v-if="canCreateEvent")
        template(v-slot:activator="{openSheet}")
          div(:style="{ width: '100%' }")
            Button(
              :btnLabel="btnLabel",
              :block="isXsScreen",
              @click="openSheet"
            )
</template>

<script>
import TopicForm from "../TopicForm/index.vue"
import EventForm from "../EventForm/EventForm.vue"
import Button from "../UI/Button.vue"

import { createNamespacedHelpers } from "vuex"
import EventSheetButton from "components/Event/EventSheetButton.vue"
import ConfirmationDialogProvider from "features/common/confirmation-dialog/ConfirmationDialogProvider.vue"
import { provideGroupContext } from "features/group/groupContext"
import { computed } from "vue"
import { usePermissionCheck } from "features/common/permissions/usePermissionCheck"
const { mapActions: mapMemberActions } = createNamespacedHelpers("member")
export default {
  name: "PortalTopicAndEventForm",
  components: {
    ConfirmationDialogProvider,
    EventSheetButton,
    TopicForm,
    EventForm,
    Button,
  },
  computed: {
    currentGroupIdFromRoute() {
      return this.$route.params.group_id || null
    },
    btnLabel() {
      return this.$t("components.event_form.new_event")
    },
    isXsScreen() {
      return this.$vuetify.breakpoint.name === "xs"
    },
  },
  methods: {
    ...mapMemberActions(["getCurrentMember"]),
  },
  async created() {
    await this.getCurrentMember()
    if (this.currentGroupIdFromRoute) {
      await this.getGroup(this.currentGroupIdFromRoute)
    }
  },
  setup() {
    const { hasClientPermission } = usePermissionCheck()

    const groupContext = provideGroupContext()

    const canCreateEvent = computed(() => {
      if (groupContext.currentGroup.value == null) {
        return hasClientPermission("ACCESS_EVENTS") // If there is no group, we can create an event, if we have the client permission.
      }
      return !!groupContext.currentGroup.value?.links?.create_event_url
    })

    const canCreateTopic = computed(() => {
      if (groupContext.currentGroup.value == null) {
        return hasClientPermission("ACCESS_GROUPS") // If there is no group, we can create a topic, if we have the client permission.
      }
      return !!groupContext.currentGroup.value?.links?.create_topic_url
    })

    return {
      getGroup: (groupId) => groupContext.getGroup(groupId),
      canCreateEvent,
      canCreateTopic,
    }
  },
}
</script>
